export default "__VITE_ASSET__CFlGBEnm__"